<template>
	<div>
		<!-- 主体内容 -->
		<div class="bg-white contentDetail">
			<div class="detailList">
				<ul>
					<li v-for="(item,index) in recruits" :key="index" @click="goDetail(item)">
						{{item.name}}
						<span class="rightDate">{{item.createAt}}</span>
					</li>
				</ul>
			</div>
			<!-- 分页 -->
			<div class="text-center">
				<el-pagination background layout="prev, pager, next"
				@current-change="getNews" :current-page="paging.currPage"
				:page-size="paging.everySize" :total="paging.allNum">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	export default{
		created() {
			this.getRecruit()
		},
		data() {
			return {
				recruits:[],
				paging: {currPage: 1, everySize: 10, allNum: 0},
				//检索条件
				condition: {}
			}
		},
		methods: {
			// 获取新闻列表
			getRecruit(currentPage){
				let vm = this
				// 区分分页与查询
				if(currentPage){
					vm.paging.currPage = currentPage;
				} else {
					vm.paging.currPage = 1;
				}
				var params = {}
				params.currPage = vm.paging.currPage
				params.everySize = vm.paging.everySize
				vm.axios.get('/api/recruit/findAllByPage',{params: params}).then(res => {
					vm.recruits = res.data.data.recruits
					vm.paging = res.data.data.pagingBean
				})
			},
			goDetail(item){
				if(item.reprintMark){
					window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/newsDetail',
					query:{
						id:item.id,
						mbx:'人才招聘',
						mbxLink:'/socialResponsibility?index=3',
						newsType:'recruit'
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	.contentDetail{
		width: 1180px;
	}
	.contentDetail .detailList{
		min-height:550px;
	}
	.contentDetail ul li{
		font-size: 18px;
		color: #666;
		min-height: 70px;
		border-bottom: 1px solid #eee;
		line-height: 70px;
		position: relative;
	}
	.contentDetail ul li .rightDate{
		position: absolute;
		right:20px;
	}
	.contentDetail ul li:hover{
		cursor: pointer;
		color: #409Eff;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>
